/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateOrganizationAdvertisementRequestOrganizationFromJSON, UpdateOrganizationAdvertisementRequestOrganizationToJSON } from './UpdateOrganizationAdvertisementRequestOrganization';
export function GetEuOrganizationDisplaySettingResponseDataFromJSON(json) {
    return GetEuOrganizationDisplaySettingResponseDataFromJSONTyped(json, false);
}
export function GetEuOrganizationDisplaySettingResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        organization: !exists(json, 'organization')
            ? undefined
            : UpdateOrganizationAdvertisementRequestOrganizationFromJSON(json['organization'])
    };
}
export function GetEuOrganizationDisplaySettingResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        organization: UpdateOrganizationAdvertisementRequestOrganizationToJSON(value.organization)
    };
}
